import React, { Component } from 'react'
import { Container } from 'reactstrap'
import { inject, observer } from 'mobx-react'
import DataWrapper from '../../principal/containers/DataWrapper'
import FiltroBigPicture from '../components/FiltroBigPicture'
import BigPictureStore from '../stores/BigPictureStore'


@observer
export class BigPicture extends Component {

    constructor(props) {
        super(props)

        this.controller = new BigPictureStore()
    }

    render() {
        return (
            <div className="form-wrapper">
                <Container className="liberacao-cabotagem px-0" fluid>
                    <FiltroBigPicture controller={this.controller} />
                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bigpicture/telas/BigPicture.js